import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { loginApi, registerApi } from "../services/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(() => {
    try { return JSON.parse(localStorage.getItem("rm:user")) || null; }
    catch { return null; }
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) localStorage.setItem("rm:user", JSON.stringify(user));
    else localStorage.removeItem("rm:user");
  }, [user]);

  async function login({ correo, password }) {
    setLoading(true);
    try {
      const { usuario } = await loginApi({ correo, password });
      setUser(usuario);              
      return usuario;
    } finally {
      setLoading(false);
    }
  }

  async function register(data) {
    setLoading(true);
    try {
      const u = await registerApi(data);
      setUser(u);
      return u;
    } finally {
      setLoading(false);
    }
  }

  function logout() { setUser(null); }
 
  const value = useMemo(() => ({
    user,
    isAuth: !!user,
    loading,
    login,
    logout,
    register,
  }), [user, loading]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth debe usarse dentro de <AuthProvider>");
  return ctx;
}
